import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectTalentAgencyState = (state) => state.talentAgencies || initialState;

export const listTalentAgencySelector = createSelector(
  [selectTalentAgencyState],
  (talentAgenciesState) => talentAgenciesState.talentAgencyList
);

export const talentAgencyCreatorsSelector = createSelector(
  [selectTalentAgencyState],
  (talentAgenciesState) => talentAgenciesState.talentAgencyMembers
);

export const managerDropdownSelector = createSelector(
  [selectTalentAgencyState],
  (talentAgenciesState) => talentAgenciesState.managerDropdown
);

export const addManagerSuccess = createSelector(
  [selectTalentAgencyState],
  (talentAgenciesState) => talentAgenciesState.addManager
);

export const updateMemberStatus = createSelector(
  [selectTalentAgencyState],
  (talentAgenciesState) => talentAgenciesState.updateMember
);

export const removeMemberStatusSelector = createSelector(
  [selectTalentAgencyState],
  (talentAgenciesState) => talentAgenciesState.removeMember
);

export const managerListSelector = createSelector(
  [selectTalentAgencyState],
  (talentAgenciesState) => talentAgenciesState.managerList
);
